// Glossary terms data for the Background tab
export const glossaryTerms = [
  {
    term: "Artificial Intelligence (AI)",
    definition: "A branch of computer science focused on creating systems capable of performing tasks that typically require human intelligence, such as learning, reasoning, problem-solving, and understanding language."
  },
  {
    term: "Large Language Model (LLM)",
    definition: "An advanced AI system trained on vast amounts of text data to understand and generate human-like text. LLMs predict the next word in a sequence based on context, enabling them to perform tasks like answering questions, summarizing information, and writing code."
  },
  {
    term: "Generative AI (GenAI)",
    definition: "A subset of AI focused on creating new content, such as text, images, audio, or video, based on patterns learned from training data. Examples include ChatGPT for text and DALL-E for images."
  },
  {
    term: "Prompt Engineering",
    definition: "The practice of crafting effective prompts to guide LLMs in generating accurate and relevant responses. It involves structuring inputs to maximize the model's performance for specific tasks."
  },
  {
    term: "Context Window",
    definition: "The amount of text (in tokens) that an LLM can process at once. It includes both the input prompt and the model's previous responses in a conversation."
  },
  {
    term: "Token",
    definition: "A unit of text (e.g., a word, part of a word, or punctuation) used by LLMs to process and generate language. The context window of an LLM is measured in tokens."
  },
  {
    term: "Neural Network",
    definition: "A computing system inspired by biological neural networks, consisting of interconnected nodes (neurons) that process and transmit information. The foundation of modern AI systems including LLMs."
  },
  {
    term: "Training Data",
    definition: "The collection of text, images, or other content used to teach an AI model patterns and relationships. The quality and quantity of training data significantly impact model performance."
  },
  {
    term: "Fine-tuning",
    definition: "The process of further training a pre-trained model on specific data to improve its performance on particular tasks or domains. This allows models to specialize in certain areas while maintaining their general capabilities."
  },
  {
    term: "Transformer Architecture",
    definition: "A neural network design that revolutionized natural language processing by enabling models to process all words in a sequence simultaneously while maintaining awareness of their relationships and context."
  },
  {
    term: "Inference",
    definition: "The process of an AI model generating responses or making predictions based on input. The time and computational resources required for inference can vary significantly between models."
  },
  {
    term: "Model Parameters",
    definition: "The variables within a neural network that are adjusted during training to capture patterns in data. More parameters generally allow for more complex understanding but require more computational resources."
  },
  {
    term: "AI Agents",
    definition: "Autonomous systems that can perceive their environment, make decisions, and take actions to achieve specific goals. AI agents can range from simple chatbots to complex systems that can browse the web, use tools, and execute multi-step tasks independently."
  }
]; 